import { render, staticRenderFns } from "./dialogSetting.vue?vue&type=template&id=128ab4a2&scoped=true&"
import script from "./dialogSetting.vue?vue&type=script&lang=js&"
export * from "./dialogSetting.vue?vue&type=script&lang=js&"
import style0 from "./dialogSetting.vue?vue&type=style&index=0&id=128ab4a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ab4a2",
  null
  
)

export default component.exports